module.exports = __webpack_public_path__ + "static/media/Impact_narrative.f1d47be1.png";